import { IUnitDetails, NumberUnitType } from "../../../../../types/assignment-filters";

export const RANGE_MIN = 0;
export const RANGE_MAX = 1000000;
export const EXP_RANGE_MAX = 360;
export const MONEY_RANGE_MAX = 5000000000000; // 5 trillion
export const EXP_RANGE_STEP = 3;
export const MONEY_RANGE_STEP = 10000; // 10k
export const RANGE_YEAR = 12;
export const MILLION_UNITS = 1000000; // 1 million
export const RANGE_SPLITTER = '-';
export const MAX_ROLE_LENGTH_YEARS = 20;

export const NumberUnitsMap: Record<NumberUnitType, IUnitDetails> = {
  [NumberUnitType.number]: {
    min: RANGE_MIN,
    max: RANGE_MAX,
    multiply: 1,
  },
  [NumberUnitType.money]: {
    min: RANGE_MIN,
    max: MONEY_RANGE_MAX,
    multiply: MILLION_UNITS,
    sub_label: 'In millions',
  },
  [NumberUnitType.year]: {
    min: RANGE_MIN,
    max: EXP_RANGE_MAX,
    multiply: RANGE_YEAR,
    sub_label: 'In years',
  },
  [NumberUnitType.year_no_multiplier]: {
    min: RANGE_MIN,
    max: MAX_ROLE_LENGTH_YEARS,
    multiply: 1,
    sub_label: 'In years',
  }
};